import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import PropTypes from "prop-types";

import PageHome from "../pages/PageHome";
import PageLogin from "../pages/PageLogin";
import { PageMain } from "../pages/PageMain";
import { PageSecond } from "../pages/PageSecond";
import { PageFavorites } from "../pages/PageFavorites";
import { PageNotifications } from "../pages/PageNotifications";
import { PageCart } from "../pages/PageCart";
import PageProfile from "../pages/PageProfile";
import PageFeedback from "../pages/PageFeedback";
import PageAboutUs from "../pages/PageAboutUs";
import PageBookings from "../pages/PageBookings";
import PaymentMethod from "../components/PaymentMethod";
import PageOrderSuccess from "../pages/PageOrderSuccess";
import PageShops from "../pages/PageShops";
import PageShopProducts from "../pages/PageShopProducts";
import PageShopCategories from "../pages/PageShopCategories";

function PagesRouter({
  cbChangedFilter,
  cbChangedSort,
  cbChangeOutputType,
  loadState,
  wineItemCode,
  loadError,
  isShowPages,
  winesArrLength,
  winesPerPage,
  cbPaginate,
  currentPage,
}) {
  return (
    <Routes>

      {/* =========================================
          ROOT
          / automatically redirects to /home
          ========================================= */}

      <Route
        path="/"
        element={<Navigate to="/home" replace />}
      />

      {/* =========================================
          HOME
          ========================================= */}

      <Route
        path="/home"
        element={<PageHome />}
      />

      {/* =========================================
          LOGIN
          ========================================= */}

      <Route
        path="/login"
        element={<PageLogin />}
      />

      {/* =========================================
          PROFILE
          ========================================= */}

      <Route
        path="/profile"
        element={<PageProfile />}
      />

      {/* =========================================
          PAYMENT METHOD
          ========================================= */}

      <Route
        path="/paymentmethod"
        element={<PaymentMethod />}
      />

      {/* =========================================
          SHOPS
          ========================================= */}

      <Route
        path="/shops"
        element={<PageShops />}
      />

      {/* =========================================
          MY BOOKINGS
          ========================================= */}

      <Route
        path="/my-bookings"
        element={<PageBookings />}
      />

      {/* =========================================
          FAVOURITE BRANDS
          ========================================= */}

      <Route
        path="/favorite-brands"
        element={
          <PageFavorites
            loadState={loadState}
            wineItemCode={wineItemCode}
            loadError={loadError}
          />
        }
      />

      {/* =========================================
          NOTIFICATIONS
          ========================================= */}

      <Route
        path="/notifications"
        element={
          <PageNotifications
            loadState={loadState}
            wineItemCode={wineItemCode}
            loadError={loadError}
          />
        }
      />

      {/* =========================================
          FEEDBACK
          ========================================= */}

      <Route
        path="/feedback"
        element={<PageFeedback />}
      />

      {/* =========================================
          ABOUT US
          ========================================= */}

      <Route
        path="/about-us"
        element={<PageAboutUs />}
      />

      {/* =========================================
          SHOP ITEM
          ========================================= */}

      <Route
        path="/shopitem"
        element={
          <PageSecond
            cbChangedFilter={cbChangedFilter}
            cbChangedSort={cbChangedSort}
            cbChangeOutputType={cbChangeOutputType}
            loadState={loadState}
            wineItemCode={wineItemCode}
            loadError={loadError}
            isShowPages={isShowPages}
            winesArrLength={winesArrLength}
            winesPerPage={winesPerPage}
            cbPaginate={cbPaginate}
            currentPage={currentPage}
          />
        }
      />

      {/* =========================================
          SHOP
          ========================================= */}

      <Route
        path="/shop"
        element={
          <PageMain
            cbChangedFilter={cbChangedFilter}
            cbChangedSort={cbChangedSort}
            cbChangeOutputType={cbChangeOutputType}
            loadState={loadState}
            wineItemCode={wineItemCode}
            loadError={loadError}
            isShowPages={isShowPages}
            winesArrLength={winesArrLength}
            winesPerPage={winesPerPage}
            cbPaginate={cbPaginate}
            currentPage={currentPage}
          />
        }
      />

      {/* =========================================
          ITALY
          ========================================= */}

      <Route
        path="/italy"
        element={
          <PageMain
            cbChangedFilter={cbChangedFilter}
            cbChangedSort={cbChangedSort}
            cbChangeOutputType={cbChangeOutputType}
            loadState={loadState}
            wineItemCode={wineItemCode}
            loadError={loadError}
            isShowPages={isShowPages}
            winesArrLength={winesArrLength}
            winesPerPage={winesPerPage}
            cbPaginate={cbPaginate}
            currentPage={currentPage}
          />
        }
      />

      {/* =========================================
          SPAIN
          ========================================= */}

      <Route
        path="/spain"
        element={
          <PageMain
            cbChangedFilter={cbChangedFilter}
            cbChangedSort={cbChangedSort}
            cbChangeOutputType={cbChangeOutputType}
            loadState={loadState}
            wineItemCode={wineItemCode}
            loadError={loadError}
            isShowPages={isShowPages}
            winesArrLength={winesArrLength}
            winesPerPage={winesPerPage}
            cbPaginate={cbPaginate}
            currentPage={currentPage}
          />
        }
      />

      {/* =========================================
          FRANCE
          ========================================= */}

      <Route
        path="/france"
        element={
          <PageMain
            cbChangedFilter={cbChangedFilter}
            cbChangedSort={cbChangedSort}
            cbChangeOutputType={cbChangeOutputType}
            loadState={loadState}
            wineItemCode={wineItemCode}
            loadError={loadError}
            isShowPages={isShowPages}
            winesArrLength={winesArrLength}
            winesPerPage={winesPerPage}
            cbPaginate={cbPaginate}
            currentPage={currentPage}
          />
        }
      />

      {/* =========================================
          NEW WORLD
          ========================================= */}

      <Route
        path="/new-world"
        element={
          <PageMain
            cbChangedFilter={cbChangedFilter}
            cbChangedSort={cbChangedSort}
            cbChangeOutputType={cbChangeOutputType}
            loadState={loadState}
            wineItemCode={wineItemCode}
            loadError={loadError}
            isShowPages={isShowPages}
            winesArrLength={winesArrLength}
            winesPerPage={winesPerPage}
            cbPaginate={cbPaginate}
            currentPage={currentPage}
          />
        }
      />

      {/* =========================================
          SHOP PRODUCTS
          ========================================= */}

      <Route
        path="/shop-products"
        element={<PageShopProducts />}
      />

      {/* =========================================
          SHOP CATEGORIES
          ========================================= */}

      <Route
        path="/shop-categories"
        element={<PageShopCategories />}
      />

      {/* =========================================
          CART
          ========================================= */}

      <Route
        path="/cart"
        element={<PageCart />}
      />

      {/* =========================================
          ORDER SUCCESS
          ========================================= */}

      <Route
        path="/order-success"
        element={<PageOrderSuccess />}
      />

    </Routes>
  );
}

PagesRouter.propTypes = {
  cbChangedFilter: PropTypes.func.isRequired,
  cbChangedSort: PropTypes.func.isRequired,
  cbChangeOutputType: PropTypes.func.isRequired,

  loadState: PropTypes.number.isRequired,

  wineItemCode: PropTypes.array,

  loadError: PropTypes.string,

  isShowPages: PropTypes.bool.isRequired,

  winesArrLength: PropTypes.number,

  winesPerPage: PropTypes.number.isRequired,

  cbPaginate: PropTypes.func.isRequired,

  currentPage: PropTypes.number.isRequired,
};

export default PagesRouter;